export default __webpack_public_path__ + "static/media/green-check-circle.204fe897.svg";